var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"rules":_vm.rules,"loading":_vm.loading,"items":_vm.items,"name":"category","placeholder":"Tipo","menu-props":_vm.menuProps}},'v-select',[_vm.fieldProps, _vm.$attrs],false))}
var staticRenderFns = []

export { render, staticRenderFns }